import { ApiResult } from './../models/ApiResult';
import { TipoInmueble } from './../models/tipoInmueble';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';


@Injectable()
export class TipoInmuebleService {

  myAppUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getTipoInmuebles(showDisabled: any) {
    let params = new HttpParams()
      .set('showDisabled',showDisabled)

    return this.http.get(this.myAppUrl + 'api/Tipoinmueble/', {params});
  }

  getTipoInmuebleByID(id: string): Observable<TipoInmueble> {
    return this.http.get<TipoInmueble>(this.myAppUrl + `api/TipoInmueble/${id}` );
  }

  updateTipoInmueble(entity: TipoInmueble): Observable<ApiResult> {
    return this.http.put<ApiResult>(`${this.myAppUrl}api/TipoInmueble/${entity.id}`, entity);
  }

  createTipoInmueble(entity: TipoInmueble): Observable<ApiResult> {
    return this.http.post<ApiResult>(`${this.myAppUrl}api/TipoInmueble/`, entity);
  }
  deleteTipoInmueble(id: string): Observable<ApiResult> {
    return this.http.delete<ApiResult>(`${this.myAppUrl}api/TipoInmueble/{id}`);
  }

}
